module.exports = __webpack_public_path__ + "media/images/icons/flags/ZM-2bb86064f3a21e5c64f3bb0b7e7be76e.svg";